export const REDUCER_NAME="themeSlice"

export interface iThemeForm {
    themeTitle?: string;
    themePrice?: string;
    description?: string;
    image?: (string | File)[];
    galleryImages?: string | File;
    zipFile?: File;
  }
  

 export interface iLockAmountResponse {
  userId: string;
  email: string;
  firstName?: string;
  lockBalance: string;
  balance: string;
  mobile?: string;
  updatedAt?: string;
  role?: number;
}


   export interface iThemeState {
      isLoading: boolean;
      lockAmountList: iLockAmountResponse[];
      errorMessage: string | null;
    }